// frontend/src/components/Manual/Manual.tsx

import React, { useState } from 'react';
import { ManualNav } from './ManualNav';
import { SectionIntro } from './sections/SectionIntro';
import './Manual.css';

// ============================================================
// SEÇÕES DISPONÍVEIS
// ============================================================
// Apenas a seção 'intro' tem conteúdo real.
// As demais serão implementadas na Fase 7.3.
// Até lá, o ManualNav só exibe as seções disponíveis.
// ============================================================

const AVAILABLE_SECTIONS = ['intro'];

export const Manual: React.FC = () => {
  const [section, setSection] = useState<string>('intro');

  const renderSection = () => {
    if (!AVAILABLE_SECTIONS.includes(section)) {
      return <SectionIntro />;
    }
    return <SectionIntro />;
  };

  return (
    <div className="manual-container">
      <div className="manual-header">
        <h1>📖 Manual do Usuário</h1>
        <p className="subtitle">
          Guia passo a passo de cada tela da plataforma
        </p>
      </div>

      <div className="manual-layout">
        <ManualNav
          active={section}
          onSelect={setSection}
          availableSections={AVAILABLE_SECTIONS}
        />
        <main className="manual-content">{renderSection()}</main>
      </div>
    </div>
  );
};

export default Manual;